var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[
    'zg-grid',
    `zg-grid--${_vm.columns}-columns`,
    `zg-grid--${_vm.mColumns}-columns-m`,
    `zg-grid--${_vm.lColumns}-columns-l`,
    `zg-grid--${_vm.gap}-gap`,{
      'zg-grid--inline': _vm.inline,
    }]},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }